import QRCode from 'qrcode.react';

interface ChildsProps {
    serie1: string
    serie2: string
    numeroGuia : number
    size: number
}

const CodigoQr: React.FC<ChildsProps> = ({serie1,serie2,numeroGuia, size}) =>  {
  const APP_URL = process.env.REACT_APP_APP_URL
  const qrValue = `${APP_URL}home/consulta/detalles/${serie1}-${serie2}-${numeroGuia}`; // Cambia esto por el valor que desees
  return (
    <div className=''>
      <QRCode 
      value={qrValue}      // URL a convertir
      level="M"            // Nivel de corrección de errores (L, M, Q, H)
      bgColor="#FFFFFF"    // Color de fondo
      fgColor="#000000"    // Color de los módulos
      size={size}
      />
    </div>
  );
}

export default CodigoQr;